import { showToast } from "./toast-config";

const errorToast = (message = "Something went wrong", options) =>
  showToast("error", message, "Something went wrong", options);

export default errorToast;
